import { render, staticRenderFns } from "./TAB_POS.vue?vue&type=template&id=01be417d&"
import script from "./TAB_POS.vue?vue&type=script&lang=js&"
export * from "./TAB_POS.vue?vue&type=script&lang=js&"
import style0 from "./TAB_POS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports